export interface ISerologyTrackingCounts {
    pendShippingCount: number,
    shippedToDonorCenterCount: number,
    shippedBackToVendorCount: number,
    completedCount: number,
    cancelledCount: number
}